import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineClientScheduleEnd のスタイル
 */
export const hotlineClientScheduleEndStyle = tv({
    slots: {
        base: [
            'flex flex-col items-center',
            'bg-blue-gray-75',
            'p-16',
            'rounded-md',
        ],
        buttonWrap: ['flex flex-col lg:flex-row gap-16', 'mt-24'],
    },
    variants: {},
});
